import { useEscapeKey } from "./useEscapeKey";
import { useBodyScrollLock } from "../../../hooks/useBodyScrollLock";
import { useHeaderBehindModal } from "../../../hooks/useHeaderBehindModal";
import { IconX } from "../../../components/ui/Icons";

export default function VideoModal({ src, onClose }) {
  useBodyScrollLock(true);
  useHeaderBehindModal(true);
  useEscapeKey(onClose);
  return (
    <div className="imgModalBackdrop" role="dialog" aria-modal="true" aria-label="Odtwarzacz wideo" onClick={onClose}>
      <div className="videoModalShell" onClick={(event) => event.stopPropagation()}>
        <div className="imgModalHd">
          <div className="imgModalTitle">Film</div>
          <button type="button" className="modalCloseBtn" onClick={onClose} aria-label="Zamknij"><IconX /></button>
        </div>
        <div className="videoModalBd"><video className="videoModalPlayer" src={src} controls playsInline preload="metadata" /></div>
      </div>
    </div>
  );
}